import {Paper, Typography} from "@mui/material";
import {Container} from "@mui/system";
import {isKuhniVersoMebelDomain, kuhniVersoTabletContainerQuerySx} from "../../utils/isKuhniVersoMebelDomain";
import Box from "@mui/material/Box";
import {BreadcrumbsComponent} from "../../components/UI/breadcrumb/BreadcrumbComponent";
import Footer from "./Footer";
import React, {useCallback, useEffect, useState} from "react";
import CardByCarousel, {catalogCardFlowSizerSx} from "../../components/UI/carousel/CardByCarousel";
import {useNavigate} from "react-router-dom";
import {constantsErrorMessages} from "../../Constants";
import ModalAlert from "../../components/UI/table/customer-detales/ModalAlert";
import CustomerCompositionController from "../../API/customer/CustomerCompositionController";
import ButtonSelectAction from "../../components/UI/button/ButtonSelectAction";
import ModalConfirm from "../../components/UI/modal/ModalConfirm";
import {
    catalogCardsGridSx,
    catalogDraftsCardWrapperSx,
    catalogDraftsCardsSectionSx,
} from "./catalogCardGridStyles";

const catalogDraftsEmptyStateSx = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    gap: "24px",
    py: "48px",
};

const CatalogDrafts = () => {
    const isKuhniVersoMebel = isKuhniVersoMebelDomain();
    const navigate = useNavigate();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [alertData, setAlertData] = useState({});
    const [draftToDelete, setDraftToDelete] = useState(null);
    const [deleteLoading, setDeleteLoading] = useState(false);

    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        });
    };

    const loadDrafts = useCallback(() => {
        setLoading(true);
        CustomerCompositionController.getDrafts()
            .then(function (response) {
                setData(Array.isArray(response.data) ? response.data : []);
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setLoading(false));
    }, []);

    useEffect(() => {
        loadDrafts();
    }, [loadDrafts]);

    const handleDeleteDraftRequest = (item) => {
        setDraftToDelete(item);
    };

    const handleDeleteDraftCancel = () => {
        setDraftToDelete(null);
    };

    const handleDeleteDraftConfirm = () => {
        if (draftToDelete?.id == null) {
            return;
        }
        setDeleteLoading(true);
        CustomerCompositionController.deleteDraft(draftToDelete.id)
            .then(function () {
                setData((prev) => prev.filter((el) => el.id !== draftToDelete.id));
                setDraftToDelete(null);
                handleModalAlert("Черновик удалён", "success");
            })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setDeleteLoading(false));
    };

    return (
        <>
            <Paper sx={{
                width: '100%',
                paddingBottom: "40px",
                display: 'flex',
                justifyContent: "space-between",
                flexGrow: 1
            }}>
                <Container sx={{
                    "&.MuiContainer-root": {
                        maxWidth: "1668px",
                        display: 'flex',
                        flexDirection: "column",
                        gridGap: "100px",
                        ...(isKuhniVersoMebel ? kuhniVersoTabletContainerQuerySx : {}),
                    },
                }}>
                    <Box>
                        <BreadcrumbsComponent
                            page={"Мои черновики"}
                            path={[
                                {name: "Главная", href: "/"},
                            ]}/>
                        <Box sx={{
                            display: "flex",
                            flexDirection: "row",
                            position: "relative",
                            width: "100%",
                            minWidth: 0,
                        }}>
                            <Box sx={catalogDraftsCardsSectionSx}>
                                {!loading && data.length === 0 ? (
                                    <Box sx={catalogDraftsEmptyStateSx}>
                                        <Typography sx={{
                                            fontSize: "16px",
                                            lineHeight: 1.4,
                                            color: (theme) => theme.palette.text.secondary,
                                            textAlign: "center",
                                        }}>
                                            У вас пока нет черновиков
                                        </Typography>
                                        <ButtonSelectAction
                                            text="Перейти в каталог"
                                            onClick={() => navigate("/catalog")}
                                            showIcon={false}
                                        />
                                    </Box>
                                ) : (
                                    <Box sx={catalogCardsGridSx}>
                                        {data.map((item) => (
                                            <Box key={item.id} sx={catalogDraftsCardWrapperSx}>
                                                <Box aria-hidden sx={catalogCardFlowSizerSx}/>
                                                <CardByCarousel
                                                    item={item}
                                                    catalogCard
                                                    draftCard
                                                    width={"100%"}
                                                    widthImg={"100%"}
                                                    compactBelow1440
                                                    onDelete={handleDeleteDraftRequest}
                                                    onClick={() => navigate(`/catalog/${item.originalId}`)}/>
                                            </Box>
                                        ))}
                                    </Box>
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Container>
            </Paper>
            <Footer/>
            <ModalAlert data={alertData} onClose={() => setAlertData((alert) => {
                return {...alert, open: false};
            })}/>
            <ModalConfirm
                title="Удалить черновик?"
                modalOpen={Boolean(draftToDelete)}
                handleClose={handleDeleteDraftCancel}
                handleSubmit={handleDeleteDraftConfirm}
                action="Удалить"
                loading={deleteLoading}
            />
        </>
    );
};

export default CatalogDrafts;
